/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FxTopBannerView } from './FxTopBannerView';
import FxRightDrawer from '../fx-right-drawer';
import { FxInvestmentAccountDrawer } from '../../DrawerPages/Treasure/FxInvestmentAccountDrawer';
import { FxButton } from '../../Action/FxButton';
import UIFeatureImpl from '../../../libs/services/uiFeatures';
import { FxFastFunding, IFastFundingPayload } from '../../DrawerPages/FxFastFunding/FxFastFunding';
import { getKey } from '../../../libs/utils/storageManager';
import { pushGTM } from '../../../libs/utils/utils';
import { MaintenanceBanner } from './MaintenanceBanner';
import {
    MAINTENANCE_BANNER_COMPONENT,
    shouldShowNotificationBanner,
    filterMaintenanceBannerFromCarousel,
} from './maintenanceBannerUtils';

const uiFeat = UIFeatureImpl.getInstance();

export type FxTopBannerContentType = React.ComponentType<{onClose:() => void, bannerData:any}>;

interface IState {
    Content?: FxTopBannerContentType;
    bannerData?: any;
}

export interface IFxTopBanner {
    show(Content: FxTopBannerContentType): void;
    closeForce(id: string): void;
    bannerData(data: any): void;
}

export class FxTopBannerController extends React.Component<object, IState> implements IFxTopBanner {

    constructor(props:any) {
        super(props);
        this.state = {};
    }

    public show = (Content: FxTopBannerContentType) => {
        this.setState({ Content });
    }

    public bannerData = (data: any) => {
        // Central gate: never render maintenance until PM settings are loaded and enabled.
        // Also blocks stale maintenance slides restored from persisted Redux on reload.
        const carouselData = shouldShowNotificationBanner()
            ? data
            : filterMaintenanceBannerFromCarousel(data);

        if (!carouselData?.length) {
            this.setState({ bannerData: [] });
            return;
        }

        const newBannerData = carouselData?.map((item: any) => {
            let componentContent: any;
            if (item.component === 'topFasterFundingcontent') {
                componentContent = !item.isMobileScreen ? (<div>
                    {uiFeat.getFasterFunding().banner}
                    <FxButton onClick={this.openFastFundingDrawer} className={'fx-button fx-button-saturated-orange'}>OPT IN</FxButton>
                </div>) : (<div><p>&nbsp;Opt in for Faster Funding.</p><FxButton onClick={this.openFastFundingDrawer} className={'fx-button fx-button-saturated-orange'}>OPT IN</FxButton></div>);
                if (item.clicked) {
                    this.openFastFundingDrawer()
                }
            } else if (item.component === MAINTENANCE_BANNER_COMPONENT) {
                // PM-driven notification banner — copy from NOTIFICATION_BANNER_* settings
                componentContent = <MaintenanceBanner />;
            }
            return { id: item.id, component: componentContent };
        })
        this.setState({ bannerData: newBannerData });
    }

    public closeForce = (id: string) => {
        const finalData = this.state?.bannerData?.filter((_d : any) => _d?.id !== id);
        this.setState({ bannerData: finalData });
    }

    /**
    * method to Open Investment Account Drawer
    */
    openPassportDrawer = (async (type: any) => {
        const userName = await getKey('userName')
        const event = type === 'CASH_BUILDER_PLUS' ? 'bannerCashBuilderPlusStartTrigger' : 'bannerCashBuilderStartTrigger';
        // Handling gtm data for cash builder and cash builder plus account while launching the banner
        const gtmData: any = {
            event,
            userName
        };
        pushGTM(gtmData)
        await FxRightDrawer.show(({ onClose }) => {
            return <FxInvestmentAccountDrawer type={type} onDrawerClose={onClose} />
        })
    })

    /**
    * method to draw fast funding banner
    */
    openFastFundingDrawer = (async () => {
        const userName = await getKey('userName')
        // Handling gtm data for faster funding while launching the banner
        const gtmData: any = {
            event: 'bannerfastFundingStartTrigger',
            userName
        }
        pushGTM(gtmData)
        await FxRightDrawer.show<IFastFundingPayload>(({ onClose }) => {
            return <FxFastFunding onDrawerClose={onClose} />
        })
        
})
    
    render = () => {
        const { bannerData } = this.state;

        if (!bannerData || bannerData?.length === 0) {
            return null;
        }

        return (
            <FxTopBannerView bannerData={bannerData} />
        );
    }
}
